import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent }       from './Login/login.component';
import { DialogComponent } from './dialog/dialog.component';
// import { CustomerComponent }    from './customer.component';
 import { CustomerDetailsComponent }      from './Customerdashboard/customerdetails.component';
 import { panelComponent }      from './panelitems/panelitems.component';
 
 import { FilterComponent }      from './filter/filter.component';
 import { CommonNavbarComponent }      from './commonnavbar/commonnavbar.component';
 import { FooterComponent }      from './footer/footer.component';
 import { DashboardComponent }      from './dashboard/dashboard.component';
 import { ShopComponent }      from './shop/shop.component';
 import { ProductDetailsComponent }      from './productdetails/productdetails.component';
 import { CategoryproductComponent } from './categoryproduct/categoryproduct.component';
import { TopsellerComponent } from './topseller/topseller.component';
import { SearchlistComponent } from './searchlist/searchlist.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { AuthGuard } from '../app/auth-guard.service';
import { NoInternetComponent } from './no-internet/no-internet.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { OrdersComponent } from './orders/orders.component';
import { CartListComponent } from './cart-list/cart-list.component';
import { OrderlistComponent } from './orderlist/orderlist.component';
import { InvoicelistComponent } from './invoicelist/invoicelist.component';
import { InvoicedescriptionComponent } from './invoicedescription/invoicedescription.component';
import { CollectpaymentComponent } from './collectpayment/collectpayment.component';
import { CartdescriptionComponent } from './cartdescription/cartdescription.component';
import { SupervisorLoginComponent } from './supervisor-login/supervisor-login.component';
import { MapsComponent } from './maps/maps.component';
import { MapstestComponent } from './mapstest/mapstest.component';

const routes: Routes = [
 { path: '',      redirectTo: 'login', pathMatch: 'full'},
 { path: 'login',     component: LoginComponent },
 { path: 'checkout',  component: CheckoutComponent },
 { path: 'admin',  component: SupervisorLoginComponent },
 { path: 'app-maps',  component: MapsComponent },
 { path: 'mapstest',  component: MapstestComponent },
 { path: 'invoicedescription',  component: InvoicedescriptionComponent },
 { path: 'invoicedescription/:invoiceNumber',  component: InvoicedescriptionComponent },
 { path: 'invoicedescription/:invoiceNumber/:isGetInvoiceDetail',  component: InvoicedescriptionComponent },
 { path: 'collect',  component: CollectpaymentComponent },
 {
  path: 'dashboard', 
  canActivate: [AuthGuard],
  canActivateChild : [AuthGuard], 
  component: DashboardComponent, children: [
    { path: 'panelbaritems',     component: panelComponent },
      { path: 'customerdetails', component: CustomerDetailsComponent },
      { path: 'order', component:  OrdersComponent, children:[
        { path: 'orderlist', component: OrderlistComponent},
      ]},
      { path: 'order/:orderNumber', component:  OrdersComponent, children:[
        { path: 'orderlist', component: OrderlistComponent},
      ]},
      { path: 'shop', component: ShopComponent, children:[
        { path: ':id/:name', component: CategoryproductComponent},
        { path: 'topsales', component: TopsellerComponent },
        { path: 'searchproduct', component: SearchlistComponent },
                
      ] },
      { path: 'invoice', component: InvoicelistComponent },
  ]
},
//  { path: 'customer',     component: CustomerComponent },
  // { path: 'customerdetails',     component: CustomerDetailsComponent },
  { path: 'app-dialog',     component: DialogComponent },
  
  
  { path: 'commonnavbar',     component: CommonNavbarComponent },
  { path: 'footerbutton',     component: FooterComponent },
  { path: 'filter',     component: FilterComponent },
  // { path: 'shop',     component: ShopComponent },
  { path: 'productdetails',     component: ProductDetailsComponent },
  { path: 'cartdetails',     component: CartdescriptionComponent },
  { path: 'nointernetconnection',     component: NoInternetComponent },
  { path: 'cartlist',     component: CartListComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: false })],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}


/*
Copyright 2017 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts